import { Component, OnInit, HostListener, Input } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { FrontDeskInstructionsService } from '../../../services/front-desk-instructions.service';
import { UrlService } from '../../../services/url.service';
declare const $: any;
@Component({
    selector: 'front-desk-instructions-list',
    templateUrl: './front-desk-instructions-list.component.html',
    styleUrls: ['./front-desk-instructions-list.component.scss']
})
export class FrontDeskInstructionsListComponent implements OnInit {

    constructor(
        public authenticationService: AuthenticationService,
        public frontDeskInstructionsService: FrontDeskInstructionsService,
        public urlService: UrlService
    ) {

    }

    ngOnInit(): void {
    }

    orderBy(orderBy: string, $event) {
        if (this.frontDeskInstructionsService.data.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showHint(e) {
        const $td = $(e.target).closest('.front-desk-instructions-list-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.front-desk-instructions-list-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    @HostListener('document:click', ['$event.target'])
    hideHint(targetElement: HTMLElement): void {
        if (!$(targetElement).closest('.front-desk-instructions-list-hint-td').length) {
            $('.front-desk-instructions-list-hint-td').removeClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/front-desk-instructions/front-desk-instructions-list/front-desk-instructions-list.component.ts